import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Feature } from "../../models/feature.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { permissionLevelsConstants } from "../../utils/constants/permission-levels.constants";

const featureKeyToPermId = Object.fromEntries(
    permissionLevelsConstants.levels
        .filter((level) => level.featureKey !== null)
        .map((level) => [
            level.featureKey,
            {
                id: level.permissionid,
                orgOnly: level.permissiontype === "ORGANISATION",
            },
        ])
);

let FeatureSettings = {
    selector: "vcFeatureSettings",
    templateUrl: "/angular/components/feature/feature-settings.component.html",
    bindings: {},
    controller: class FeatureSettingsController {
        private readonly $scope: any;
        private readonly permissionCheck: PermissionCheck;
        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;
        private readonly modelUtils: any;
        public featurePermissions: any[];
        public categories: any[] = [];
        public user: User;
        public isLeaderView: boolean;
        public isOrganisationCampaign: boolean;
        private featuresWithExtraSettings: string[] = [
            "AUTO_GENERATE_VOTER_NAME",
            "RECEPTION",
        ];

        constructor(
            $scope: any,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.permissionCheck = PermissionCheck;
            this.toast = ToastUtils;
            this.modelUtils = ModelsUtils;
            this.dialog = DialogUtils;

            this.isOrganisationCampaign =
                CampaignDataProvider.activeCampaign.isOrganisationCampaign();
            this.isLeaderView = __app_type == "LEADER";

            PermissionCheck.getFeaturePermissions().then(
                (featurePermission: any) => {
                    this.featurePermissions = featurePermission;
                    this.user = UserDataProvider.getActiveUser();
                    _.forEach(this.featurePermissions, (feature: Feature) => {
                        if (
                            this.user.isAdmin() ||
                            feature.attributes.status != "Hidden"
                        ) {
                            let found = false;
                            _.forEach(this.categories, (category: any) => {
                                if (
                                    category.id == feature.attributes.category
                                ) {
                                    found = true;
                                    category.features.push(
                                        this.modelUtils.feature(
                                            feature.attributes
                                        )
                                    );
                                }
                            });
                            if (!found && feature.attributes.category) {
                                this.categories.push({
                                    id: feature.attributes.category,
                                    name: feature.attributes.category_name,
                                    features: [
                                        this.modelUtils.feature(
                                            feature.attributes
                                        ),
                                    ],
                                });
                            }
                        }
                    });
                }
            );
        }

        hasExtraSettings(feature: any): boolean {
            return this.featuresWithExtraSettings.indexOf(feature.index) > -1;
        }

        openFeatureExtra(feature: any, $event: any): void {
            let component = `vc-feature-${feature.index
                .toLowerCase()
                .split("_")
                .join("-")}-dialog`;
            this.dialog
                .show({
                    scope: this.$scope,
                    preserveScope: true,
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    component: component,
                    locals: {
                        feature: _.cloneDeep(feature),
                        isOrgCampaign: this.isOrganisationCampaign,
                        openFeatureExtra: this.openFeatureExtra,
                    },
                    clickOutsideToClose: true,
                })
                .then((featureUpdated: Feature) => {
                    angular.extend(feature, featureUpdated);
                    this.updateFeaturePermission(featureUpdated);
                    this.permissionCheck.updateFeaturePermission(feature);
                });
        }

        updateFeaturePermission(feature: Feature): void {
            feature.update().then(
                () => {},
                (error: object) => {
                    if (error && error[0] && error[0].detail) {
                        this.toast.error(error[0].detail);
                    } else {
                        this.toast.error();
                    }
                }
            );
        }

        openFeatureSettings(feature: Feature, $event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog
                .show({
                    component: "vc-feature-settings-dialog",
                    scope: this.$scope,
                    targetEvent: $event,
                    parent: parentEl,
                    locals: {
                        feature: _.cloneDeep(feature),
                    },
                    clickOutsideToClose: true,
                    preserveScope: true,
                    ariaLabel: "Feature Settings",
                })
                .then((featureUpdated: object) => {
                    feature.setData(featureUpdated);
                    this.updateFeaturePermission(feature);
                    this.permissionCheck.updateFeaturePermission(feature);
                });
        }

        makePermission(feature: object): string[] {
            let arrayPermission = [];
            _.keys(feature).forEach((key: string): void => {
                const mapping = featureKeyToPermId[key];
                if (feature[key] === 1 && mapping) {
                    if (!mapping.orgOnly || this.isOrganisationCampaign) {
                        const name = this.permissionCheck.getPermission(
                            mapping.id
                        )?.permissionname;
                        if (name) arrayPermission.push(name);
                    }
                }
            });
            if (
                (arrayPermission.length === 5 &&
                    !this.isOrganisationCampaign &&
                    !this.isLeaderView) ||
                (arrayPermission.length === 8 &&
                    (this.isOrganisationCampaign || this.isLeaderView))
            ) {
                return ["All users"];
            }
            return arrayPermission;
        }
    },
};

// angular.module("feature").component(FeatureSettings.selector, FeatureSettings);
angular.module("feature").component(FeatureSettings.selector, FeatureSettings);
